module.exports = __webpack_public_path__ + "img/Laptop feeding data.89012eea.png";